import { Box } from "@mui/material";

function Footer() {
    return <Box sx={{ height: "min(25%, 300px)", marginTop: 5, padding: 3 }}></Box>;
}

export default Footer;
